"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalFacingLoanApplicationStatus = exports.HomeownersInsuranceFlowStatus = exports.EscrowElection = exports.DENIED_LOAN_APPLICATION_STATUSES = exports.TERMINAL_NON_APPROVED_LOAN_APPLICATION_STATUSES = exports.terminalLoanApplicationStatuses = exports.LoanApplicationStatus = exports.AutoApplicationType = exports.LOAN_APPLICATION_TYPES_ENABLE_DELINQUENCY_MODEL_HARDCUTS = exports.REUNDERWRITING_LOAN_APPLICATION_TYPES = exports.MOFO_LOAN_APPLICATION_TYPES = exports.LoanApplicationType = void 0;
/** @TranslateToPython @TranslateToEnum */
var LoanApplicationType;
(function (LoanApplicationType) {
    LoanApplicationType["AVEN_ORIGINATION"] = "AVEN_ORIGINATION";
    LoanApplicationType["AVEN_ORIGINATION_DRYRUN"] = "AVEN_ORIGINATION_DRYRUN";
    LoanApplicationType["AVEN_MLO_ORIGINATION"] = "AVEN_MLO_ORIGINATION";
    LoanApplicationType["AVEN_HOME_REATTACH"] = "AVEN_HOME_REATTACH";
    LoanApplicationType["AVEN_HOME_REUNDERWRITING_LINE_SIZE_INCREASE"] = "AVEN_HOME_REUNDERWRITING_LINE_SIZE_INCREASE";
    LoanApplicationType["AVEN_HOME_REUNDERWRITING_LINE_SIZE_INCREASE_DRYRUN"] = "AVEN_HOME_REUNDERWRITING_LINE_SIZE_INCREASE_DRYRUN";
    LoanApplicationType["AVEN_HOME_REUNDERWRITING_APR_REDUCTION"] = "AVEN_HOME_REUNDERWRITING_APR_REDUCTION";
    LoanApplicationType["AVEN_HOME_CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP"] = "AVEN_HOME_CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP";
    LoanApplicationType["AVEN_HOME_CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP_DRYRUN"] = "AVEN_HOME_CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP_DRYRUN";
    LoanApplicationType["_AVEN_WAITLIST"] = "AVEN_WAITLIST";
    LoanApplicationType["_AVEN_HOME_REUNDERWRITING_ANNUAL_RENEWAL"] = "AVEN_HOME_REUNDERWRITING_ANNUAL_RENEWAL";
    LoanApplicationType["_MORTGAGE_BROKERING"] = "MORTGAGE_BROKERING";
    LoanApplicationType["AVEN_HOME_REUNDERWRITING_POLICY_CHANGE"] = "AVEN_HOME_REUNDERWRITING_POLICY_CHANGE";
    LoanApplicationType["AVEN_UCC_ORIGINATION"] = "AVEN_UCC_ORIGINATION";
    LoanApplicationType["AVEN_UCC_ORIGINATION_DRYRUN"] = "AVEN_UCC_ORIGINATION_DRYRUN";
    LoanApplicationType["AVEN_UCC_REUNDERWRITING_LINE_SIZE_INCREASE"] = "AVEN_UCC_REUNDERWRITING_LINE_SIZE_INCREASE";
    LoanApplicationType["AVEN_UCC_REUNDERWRITING_LINE_SIZE_INCREASE_DRYRUN"] = "AVEN_UCC_REUNDERWRITING_LINE_SIZE_INCREASE_DRYRUN";
    /** @deprecated Superseded by {@link LoanApplicationType.AVEN_UCC_REUNDERWRITING_LINE_SIZE_INCREASE}. Existing loan applications only; never mint a new one. */
    LoanApplicationType["AVEN_UCC_REUNDERWRITING_CLI_NO_HARD_PULL_NO_COMMS"] = "AVEN_UCC_REUNDERWRITING_CLI_NO_HARD_PULL_NO_COMMS";
    LoanApplicationType["AVEN_MORTGAGE_ORIGINATION"] = "AVEN_MORTGAGE_ORIGINATION";
    LoanApplicationType["AVEN_DEPOSIT_ORIGINATION"] = "AVEN_DEPOSIT_ORIGINATION";
    LoanApplicationType["AVEN_CRYPTO_ORIGINATION"] = "AVEN_CRYPTO_ORIGINATION";
    LoanApplicationType["AVEN_CRYPTO_REUNDERWRITING"] = "AVEN_CRYPTO_REUNDERWRITING";
})(LoanApplicationType || (exports.LoanApplicationType = LoanApplicationType = {}));
exports.MOFO_LOAN_APPLICATION_TYPES = [LoanApplicationType.AVEN_HOME_CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP, LoanApplicationType.AVEN_HOME_CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP_DRYRUN];
/**  @TranslateToPython  */
exports.REUNDERWRITING_LOAN_APPLICATION_TYPES = [
    LoanApplicationType._AVEN_HOME_REUNDERWRITING_ANNUAL_RENEWAL,
    LoanApplicationType.AVEN_HOME_REUNDERWRITING_LINE_SIZE_INCREASE,
    LoanApplicationType.AVEN_HOME_REUNDERWRITING_LINE_SIZE_INCREASE_DRYRUN,
    LoanApplicationType.AVEN_HOME_REUNDERWRITING_APR_REDUCTION,
    LoanApplicationType.AVEN_HOME_CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP,
    LoanApplicationType.AVEN_HOME_CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP_DRYRUN,
    LoanApplicationType.AVEN_HOME_REUNDERWRITING_POLICY_CHANGE,
    LoanApplicationType.AVEN_UCC_REUNDERWRITING_LINE_SIZE_INCREASE,
    LoanApplicationType.AVEN_UCC_REUNDERWRITING_LINE_SIZE_INCREASE_DRYRUN,
    LoanApplicationType.AVEN_UCC_REUNDERWRITING_CLI_NO_HARD_PULL_NO_COMMS,
    LoanApplicationType.AVEN_CRYPTO_REUNDERWRITING,
];
/**
 * @TranslateToPython
 * @deprecated in TypeScript, do not use this array.  instead use loanApplication.dqModelHardcutsEnabled.
 * the only use case of this array in TS should be to assert it agrees with loanApplication.dqModelHardcutsEnabled
 */
exports.LOAN_APPLICATION_TYPES_ENABLE_DELINQUENCY_MODEL_HARDCUTS = [
    LoanApplicationType.AVEN_ORIGINATION,
    LoanApplicationType.AVEN_ORIGINATION_DRYRUN,
    LoanApplicationType.AVEN_MLO_ORIGINATION,
    LoanApplicationType.AVEN_HOME_REATTACH,
];
/** @TranslateToPython @TranslateToEnum */
var AutoApplicationType;
(function (AutoApplicationType) {
    AutoApplicationType["AVEN_ORIGINATION"] = "AVEN_ORIGINATION";
})(AutoApplicationType || (exports.AutoApplicationType = AutoApplicationType = {}));
/** @TranslateToPython @TranslateToEnum */
var LoanApplicationStatus;
(function (LoanApplicationStatus) {
    LoanApplicationStatus["pending"] = "pending";
    // The suspense status is used to salvage LAs which would otherwise have been denied/ineligible
    // applicants would be able to upload documents to dispute the reason for their denial, if applicable.
    // If they are successful, they will be run through UW again with an override for their denial.
    LoanApplicationStatus["decisionSuspended"] = "decisionSuspended";
    LoanApplicationStatus["lienInformationVerification"] = "lienInformationVerification";
    LoanApplicationStatus["lienInformationVerified"] = "lienInformationVerified";
    LoanApplicationStatus["nameMismatchRemedy"] = "nameMismatchRemedy";
    LoanApplicationStatus["nameMismatchVerification"] = "nameMismatchVerification";
    LoanApplicationStatus["nameMismatchVerified"] = "nameMismatchVerified";
    LoanApplicationStatus["nameMismatchRemedyQual"] = "nameMismatchRemedyQual";
    LoanApplicationStatus["nameMismatchVerificationQual"] = "nameMismatchVerificationQual";
    LoanApplicationStatus["preQualified"] = "preQualified";
    LoanApplicationStatus["preQualificationAccepted"] = "preQualificationAccepted";
    // For flows like ucc where we don't have a notary, but we still need to wait for the applicant to sign the documents
    LoanApplicationStatus["awaitingDocumentSignatures"] = "awaitingDocumentSignatures";
    // all applicants have signed the documents
    LoanApplicationStatus["documentSignaturesComplete"] = "documentSignaturesComplete";
    LoanApplicationStatus["incomeVerification"] = "incomeVerification";
    /**
     * @deprecated https://app.asana.com/0/1202417121136654/1205534272232339/f deprecate plaid verification state and queue
     */
    LoanApplicationStatus["_plaidVerification"] = "plaidVerification";
    LoanApplicationStatus["incomeVerified"] = "incomeVerified";
    LoanApplicationStatus["onsiteAVMVerification"] = "onsiteAVMVerification";
    LoanApplicationStatus["onsiteAVMVerified"] = "onsiteAVMVerified";
    LoanApplicationStatus["involuntaryLienVerification"] = "involuntaryLienVerification";
    LoanApplicationStatus["involuntaryLienVerified"] = "involuntaryLienVerified";
    LoanApplicationStatus["activeForeclosureVerification"] = "activeForeclosureVerification";
    LoanApplicationStatus["activeForeclosureVerified"] = "activeForeclosureVerified";
    LoanApplicationStatus["ofacVerification"] = "ofacVerification";
    LoanApplicationStatus["ofacVerified"] = "ofacVerified";
    LoanApplicationStatus["offered"] = "offered";
    LoanApplicationStatus["accepted"] = "accepted";
    LoanApplicationStatus["coOwnerDispute"] = "coOwnerDispute";
    // Origination flood-zone determination is outstanding (typically because CoreLogic Life of Loan
    // research is pending). The applicant is blocked on a thanks page and resumes automatically when
    // the determination resolves. Distinct from floodInsuranceVerification, which means we *know* the
    // applicant needs to provide proof of insurance.
    LoanApplicationStatus["floodZoneDeterminationPending"] = "floodZoneDeterminationPending";
    LoanApplicationStatus["floodInsuranceVerification"] = "floodInsuranceVerification";
    // offer accepted AND coOwner / trust information has been gathered
    LoanApplicationStatus["awaitingSuccessfulNotarizations"] = "awaitingSuccessfulNotarizations";
    // all applicants have gone through all the notarizations successfully but the account has not been approved yet due to fraud flag
    LoanApplicationStatus["notarizationsComplete"] = "notarizationsComplete";
    // applicant contacted us to request withdrawal of application prior to approved
    LoanApplicationStatus["withdrawn"] = "withdrawn";
    // application was offered, but applicant refused to accept
    LoanApplicationStatus["declined"] = "declined";
    LoanApplicationStatus["approved"] = "approved";
    LoanApplicationStatus["denied"] = "denied";
    /** @deprecated No longer produced. Existing historical records in the DB use this value. LAs now persist their real terminal status (denied/ineligible/humanInvestigate) directly. */
    LoanApplicationStatus["trialDenialDm"] = "trialDenialDm";
    LoanApplicationStatus["deniedIndividualCanAddCoApplicant"] = "deniedIndividualCanAddCoApplicant";
    LoanApplicationStatus["humanInvestigate"] = "humanInvestigate";
    LoanApplicationStatus["ineligible"] = "ineligible";
    LoanApplicationStatus["incomplete"] = "incomplete";
    // In Jan 2024, we split original 'incomplete' status into two groups:
    //   - 'incomplete' where we've never offered to this LA;
    //   - 'offeredNotApproved' where we've offered to this LA.
    // We need this breakdown for reporting purpose, i.e., 'offeredNotApproved' LAs should not be
    // reported as NOIed. See this doc for more details: https://docs.google.com/document/d/1tRA9jQv5AB13GxMtuIHpyUdh3dOndHOz6Mfx2e9Cars/edit#heading=h.rmtsqj2je9e8
    LoanApplicationStatus["offeredNotApproved"] = "offeredNotApproved";
    LoanApplicationStatus["duplicate"] = "duplicate";
    LoanApplicationStatus["blocked"] = "blocked";
    LoanApplicationStatus["mobileNotary"] = "mobileNotary";
    // Application never reached approved status, but account was closed
    LoanApplicationStatus["closedAccountNeverApproved"] = "closedAccountNeverApproved";
    // Terminal status for applications the system cancelled because no product was available to
    // offer (e.g. LAs that slipped past an upstream waitlist/state-block gate). The specific
    // reason is recorded in `loan_application_update.rationale` + `metadata.freeformRationale`.
    // Per L&C, excluded from HMDA, MCR, AAN, and partner-postback gates. Distinct from:
    //   - `denied` / `ineligible`: Aven received the application and refused it — both produce a
    //     HMDA `applicationDenied` row + AAN. `cancelled` means Aven never had a product
    //     to offer; no application processing happened.
    //   - `withdrawn`: applicant-initiated (HMDA reportable, MCR AC050).
    //   - `incomplete`: applicant abandoned (HMDA reportable, MCR AC060).
    LoanApplicationStatus["cancelled"] = "cancelled";
})(LoanApplicationStatus || (exports.LoanApplicationStatus = LoanApplicationStatus = {}));
/** @TranslateToPython */
exports.terminalLoanApplicationStatuses = [
    LoanApplicationStatus.incomplete,
    LoanApplicationStatus.offeredNotApproved,
    LoanApplicationStatus.duplicate,
    LoanApplicationStatus.ineligible,
    LoanApplicationStatus.denied,
    LoanApplicationStatus.deniedIndividualCanAddCoApplicant,
    LoanApplicationStatus.approved,
    LoanApplicationStatus.blocked,
    LoanApplicationStatus.withdrawn,
    LoanApplicationStatus.declined,
    LoanApplicationStatus.closedAccountNeverApproved,
    LoanApplicationStatus.cancelled,
];
// Explicitly typed: TS >= 5.5 infers a type predicate from this filter and narrows the array, which breaks `.includes(<wide enum>)` callers
exports.TERMINAL_NON_APPROVED_LOAN_APPLICATION_STATUSES = exports.terminalLoanApplicationStatuses.filter((status) => status !== LoanApplicationStatus.approved);
// The two terminal credit-denial statuses (both fire an AAN via aanRule). Excludes ineligible / humanInvestigate.
exports.DENIED_LOAN_APPLICATION_STATUSES = [LoanApplicationStatus.denied, LoanApplicationStatus.deniedIndividualCanAddCoApplicant];
/**
 * Simplified loan application status for external partners (e.g., contractors).
 * This abstracts away the internal LoanApplicationStatus into user-friendly categories
 * that don't expose internal implementation details.
 */
var EscrowElection;
(function (EscrowElection) {
    EscrowElection["optedIn"] = "optedIn";
    EscrowElection["optedOut"] = "optedOut";
})(EscrowElection || (exports.EscrowElection = EscrowElection = {}));
var HomeownersInsuranceFlowStatus;
(function (HomeownersInsuranceFlowStatus) {
    HomeownersInsuranceFlowStatus["notApplicable"] = "notApplicable";
    HomeownersInsuranceFlowStatus["waitingDocuments"] = "waitingDocuments";
    HomeownersInsuranceFlowStatus["documentPendingReview"] = "documentPendingReview";
    HomeownersInsuranceFlowStatus["documentReviewSuccess"] = "documentReviewSuccess";
    HomeownersInsuranceFlowStatus["reviewFailWaitingDocumentResubmission"] = "reviewFailWaitingDocumentResubmission";
})(HomeownersInsuranceFlowStatus || (exports.HomeownersInsuranceFlowStatus = HomeownersInsuranceFlowStatus = {}));
/**
 * Loan-application status exposed to contractors via the portal API
 * (`ClientApplicationOutput.status`). Abstracts internal `LoanApplicationStatus` to hide
 * implementation detail. Mirror of `aven_contracts/.../ExternalFacingLoanApplicationStatus`
 * — keep in sync; mapping lives in `externalFacingLoanApplicationUtils.ts`.
 */
var ExternalFacingLoanApplicationStatus;
(function (ExternalFacingLoanApplicationStatus) {
    /** Application is still being reviewed or processed */
    ExternalFacingLoanApplicationStatus["Pending"] = "Pending";
    /** Applicant has been pre-qualified for an offer */
    ExternalFacingLoanApplicationStatus["PreQualified"] = "PreQualified";
    /** A final offer has been made, waiting for applicant decision */
    ExternalFacingLoanApplicationStatus["FinalOffer"] = "FinalOffer";
    /** Applicant has accepted the final offer; in notarization */
    ExternalFacingLoanApplicationStatus["FinalOfferAccepted"] = "FinalOfferAccepted";
    /** Going through verification or closing sub-steps that aren't notarization */
    ExternalFacingLoanApplicationStatus["InProgress"] = "InProgress";
    /** Application is approved and account is active */
    ExternalFacingLoanApplicationStatus["Approved"] = "Approved";
    /** Application was denied */
    ExternalFacingLoanApplicationStatus["Denied"] = "Denied";
    /** Application expired without completion */
    ExternalFacingLoanApplicationStatus["Expired"] = "Expired";
    /** Applicant withdrew their application */
    ExternalFacingLoanApplicationStatus["Withdrawn"] = "Withdrawn";
    /** Applicant declined the offer */
    ExternalFacingLoanApplicationStatus["Declined"] = "Declined";
    /** System-cancelled — not applicant-initiated, not a credit denial. Distinct from `Expired`, `Withdrawn`, `Denied`. */
    ExternalFacingLoanApplicationStatus["Cancelled"] = "Cancelled";
})(ExternalFacingLoanApplicationStatus || (exports.ExternalFacingLoanApplicationStatus = ExternalFacingLoanApplicationStatus = {}));
